import { groupByDateAsArray, groupByYearMonthDay } from '../lib/_log_tool.js';
import { enableHorizontalDragScroll } from '../lib/_drag.js';
export let logVisualize = {
	data: [],
	yearMonth: [],
	target: null,
	calendarTarget: null,
	isMobile: false,
	setArray: function( $blocks ){
		let $target = $blocks.querySelector(`[data-page="log"]`);
		if( $target ){
			logVisualize.target 		= $target.querySelector(".c-list_history");
			logVisualize.calendarTarget = $target.querySelector("#c-log_ym");
			const raw = localStorage.getItem("pjax.visit.log");
			if (raw) {
				const parsed = JSON.parse(raw);
				if (Array.isArray(parsed)) entries = parsed;
				logVisualize.data 		= groupByDateAsArray(parsed);
				logVisualize.yearMonth 	= groupByYearMonthDay(logVisualize.data);
				//logVisualize.data = test;
				//logVisualize.yearMonth 	= groupByYearMonthDay(logVisualize.data, { mode: "grouped"});
				
				logVisualize.makeBaseHTML();
				logVisualize.makeYearMonth();
			}
		}
		window.addEventListener("resize", () => {
			logVisualize.resize({
				months: logVisualize.yearMonth.map(y => y.months.length),
				monthTotal: logVisualize.yearMonth.reduce((acc, y) => acc + y.months.length, 0)
			});
		});
	},
	makeBaseHTML: function(){
		let HTML = "";
		
		logVisualize.data.forEach( (date, index) => {
			let d = date;
			HTML += `<div class="c-day" data-date="${d.date}">
						<div class="c-day_inner">
							<div class="c-ttl_day">
								<h3>${d.date}</h3>
							</div>
							<div class="c-list_daylog">
								<ul>
								</ul>
								<svg class="day-connector"></svg>
							</div>
						</div>
					</div>`;
			//console.log(d);
		});
		logVisualize.target.innerHTML = HTML;
		
		logVisualize.makeContent();
	},
	makeContent: function(){
		let $days = logVisualize.target.querySelectorAll(".c-day");
		logVisualize.data.forEach( (date, index) => {
			let d = date;
			let HTML = "";
			for(let i = 0; i < d.items.length; i++){
				let item = d.items[i];
				let url = item.url;
				let color = item.color;
				if( url.includes("/products/") ){
					console.log(item);
				}
				const path = url.replace(/^https?:\/\/[^/]+/, "");
				let productNum = "";
				if( path.includes("/products/") ){
					if( item.productTitle != "" ){
						productNum = item.productTitle + " ";
					}
				}
				HTML += `<li data-category-slug="${item.categorySlug}" data-category-name="${item.categoryName}" data-time="${item.ts}">
							<a href="${path}" class="js-pjax">
								<div class="inr">
									<p>
										<span class="ja"><span class="txt">${productNum}${item.titleJa}</span></span>
										<span class="en"><span class="txt">${item.titleEn}</span></span>
									</p>
								</div>
							</a>
						</li>`;
			}
			$days[index].querySelector(".c-list_daylog ul").innerHTML = HTML;
		});
		requestAnimationFrame(logVisualize.drawConnectors);
	},
	drawConnectors: function () {
		
		if( logVisualize.target ){
			const days = [...logVisualize.target.querySelectorAll(".c-day")];
			
			for (let i = 0; i < days.length - 1; i++) {
				const currentDay = days[i];
				const nextDay = days[i + 1];
				const svg = currentDay.querySelector("svg.day-connector");
			
				const currentItems = [...currentDay.querySelectorAll("li[data-category-slug]")];
				const nextItems = [...nextDay.querySelectorAll("li[data-category-slug]")];
			
				// slug ごとに複数ノードを保持
				const slugMapCurrent = {};
				currentItems.forEach((li) => {
					const slug = li.dataset.categorySlug;
					const rect = li.getBoundingClientRect();
					const base = svg.getBoundingClientRect();
					let { cx, cy } = ( () => {
						if (logVisualize.isMobile) {
							return {
								cx: rect.left + rect.width / 2 - base.left,
								cy: rect.bottom - base.top // bottom から出す
							};
						} else {
							return {
								cx: rect.left + rect.width - base.left,
								cy: rect.top + rect.height / 2 - base.top // 中央から横へ
							};
						}
					})();
					
			
					if (!slugMapCurrent[slug]) slugMapCurrent[slug] = [];
					slugMapCurrent[slug].push({ cx, cy });
				});
			
				const slugMapNext = {};
				nextItems.forEach((li) => {
					const slug = li.dataset.categorySlug;
					const rect = li.getBoundingClientRect();
					const base = svg.getBoundingClientRect();
					let { cx, cy } = (() => {
						if (logVisualize.isMobile) {
							return {
								cx: rect.left + rect.width / 2 - base.left,
								cy: rect.top - base.top // 上から入る
							};
						} else {
							return {
								cx: rect.left - base.left,
								cy: rect.top + rect.height / 2 - base.top // 中央へ
							};
						}
					})();
					if (!slugMapNext[slug]) slugMapNext[slug] = [];
					slugMapNext[slug].push({ cx, cy });
				});
			
				// 両日とも存在する slug に対して全組み合わせで線を描く
				Object.keys(slugMapCurrent).forEach((slug) => {
					if (!slugMapNext[slug]) return;
			
					const fromNodes = slugMapCurrent[slug];
					const toNodes = slugMapNext[slug];
			
					fromNodes.forEach((from, fromIndex) => {
						toNodes.forEach((to, toIndex) => {
							// ここで任意の接続ルールにすることも可能（例：index一致のみなど）
			
							const isMobile = logVisualize.isMobile;
							const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
							
							const d = isMobile
								? `M ${from.cx} ${from.cy}
								   C ${from.cx} ${from.cy + 40},
									 ${to.cx} ${to.cy - 40},
									 ${to.cx} ${to.cy}`
								: `M ${from.cx} ${from.cy}
								   C ${from.cx + 40} ${from.cy},
									 ${to.cx - 40} ${to.cy},
									 ${to.cx} ${to.cy}`;
							
							path.setAttribute("d", d);
							path.setAttribute("fill", "none");
							path.setAttribute("stroke", "rgba(1, 1, 1, .5)");
							path.setAttribute("stroke-width", "1");
			
							svg.appendChild(path);
						});
					});
				});
			}
			logVisualize.nav();
		}
		
	},
	makeYearMonth: function(){
		//console.log(logVisualize.yearMonth);
		let HTML = "";
		let itemData = {
			total: 0,
			monthTotal: 0,
			months: []
		}
		logVisualize.yearMonth.forEach( (yearData, index) => {
			//console.log(yearData);
			let y = yearData.year;
			let mlen = yearData.months.length;
			itemData.months.push(mlen);
			itemData.monthTotal += mlen;
			HTML += `<div class="year" data-year="${y}" data-month-count="${mlen}">
						<p>${y}</p>
						<div class="months">
					`
			yearData.months.forEach( (monthData, mIdx) => {
				let m = monthData.month;
				let mTxt = "";
				mTxt = `<p>${m}</p>`;
				HTML += `<div class="m" data-month="${m}" data-day-count="${monthData.days.length}">${mTxt}<div class="days">`;
				monthData.days.forEach( (daysData, dIdx) => {
					HTML += `<div class="d" data-day="${m}_${daysData.day}" data-date="${daysData.day}" data-len="${daysData.items.length}"></div>`;
					itemData.count++;
				});
				HTML += `</div></div>`;
			});
			HTML += `</div></div>`;
		});
		logVisualize.calendarTarget.querySelector(".years").innerHTML = HTML;
		logVisualize.resize(itemData);
	},
	resize: function(itemData){
		//console.log("resize:", itemData);
		this.isMobile = window.innerWidth < 960;
		//console.log(this.isMobile)
		let years = document.querySelectorAll(".year");
		years.forEach( (y, index) => {
			let m = itemData.months[index];
			let w = 100/itemData.monthTotal*m;
			y.style.width = w + "%";
		});
		enableHorizontalDragScroll();
		//SVGのりサイズをする
		requestAnimationFrame(() => {
			// まず既存の path を削除
			document.querySelectorAll("svg.day-connector").forEach(svg => svg.innerHTML = "");
			logVisualize.drawConnectors();
		});
	},
	nav: function(){
		let $lists = document.querySelectorAll(".c-day li a");
		if( !this.isMobile ){
			$lists.forEach( ($list, index) => {
				$list.removeEventListener("mouseenter", logVisualize.enter, false);
				$list.removeEventListener("mouseleave", logVisualize.leave, false);
				
				$list.addEventListener("mouseenter", logVisualize.enter, false);
				$list.addEventListener("mouseleave", logVisualize.leave, false);
			});
		}
		console.log($lists);
	},
	enter: function(e){
		let thisBlock = e.currentTarget;
		let $lists = document.querySelectorAll(".c-day li a");
		let href = thisBlock.getAttribute("href");
		$lists.forEach( ($l, index) => {
			let _href = $l.getAttribute("href");
			if( href === _href ){
				$l.classList.add("hover");
			}
		});
	},
	leave: function(e){
		let thisBlock = e.currentTarget;
		let $lists = document.querySelectorAll(".c-day li a");
		let href = thisBlock.getAttribute("href");
		$lists.forEach( ($l, index) => {
			let _href = $l.getAttribute("href");
			if( href === _href ){
				if( $l.classList.contains("hover") ){
					$l.classList.remove("hover");
				}
				
			}
		});
	}
}
/*
let test = [
	{
		"date": "2025-09-20",
		"items": [
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "グッドイヤーウェルト製法",
				"titleJa": "グッドイヤーウェルト製法",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ1",
				"categorySlug": "category1",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "アグレット",
				"titleEn": "Aglet",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "REGALの歴史",
				"titleEn": "History of REGAL",
				"categoryName": "カテゴリ4",
				"categorySlug": "category4",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "フルグレインレザー",
				"titleEn": "Full Grain Leather",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "フルグレインレザー",
				"titleEn": "Full Grain Leather",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "テスト2",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "グッドイヤーウェルト製法",
				"titleJa": "グッドイヤーウェルト製法",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ1",
				"categorySlug": "category1",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "アグレット",
				"titleEn": "Aglet",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "REGALの歴史",
				"titleEn": "History of REGAL",
				"categoryName": "カテゴリ4",
				"categorySlug": "category4",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "フルグレインレザー",
				"titleEn": "Full Grain Leather",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "フルグレインレザー",
				"titleEn": "Full Grain Leather",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "テスト2",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			}
		]
	},
	{
		"date": "2025-09-19",
		"items": [
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "フルグレインレザー",
				"titleEn": "Full Grain Leather",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "テスト2",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			}
		]
	},
	{
		"date": "2025-09-18",
		"items": [
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "グッドイヤーウェルト",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ1",
				"categorySlug": "category1",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "フルグレインレザー",
				"titleEn": "Full Grain Leather",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "テスト2",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			}
		]
	},
	{
		"date": "2025-08-01",
		"items": [
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "グッドイヤーウェルト",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ1",
				"categorySlug": "category1",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "アグレット",
				"titleEn": "Aglet",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "リベット",
				"titleEn": "Full Grain Rivet",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			}
		]
	},
	{
		"date": "2025-07-25",
		"items": [
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "アグレット",
				"titleEn": "Aglet",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "グッドイヤーウェルト",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ1",
				"categorySlug": "category1",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "リベット",
				"titleEn": "Full Grain Rivet",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "REGALの歴史",
				"titleEn": "History of REGAL",
				"categoryName": "カテゴリ4",
				"categorySlug": "category4",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "ハンドウェルテッド製法",
				"titleEn": "Hand Welt",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			}
		]
	},
	{
		"date": "2025-06-01",
		"items": [
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "アグレット",
				"titleEn": "Aglet",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "グッドイヤーウェルト",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ1",
				"categorySlug": "category1",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "リベット",
				"titleEn": "Full Grain Rivet",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "REGALの歴史",
				"titleEn": "History of REGAL",
				"categoryName": "カテゴリ4",
				"categorySlug": "category4",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "ハンドウェルテッド製法",
				"titleEn": "Hand Welt",
				"categoryName": "カテゴリ3",
				"categorySlug": "category3",
				"ts": 1758072228543
			}
		]
	},
	{
		"date": "2025-02-15",
		"items": [
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "グッドイヤーウェルト",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ1",
				"categorySlug": "category1",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "アグレット",
				"titleEn": "Aglet",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			}
		]
	},
	{
		"date": "2024-12-30",
		"items": [
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "グッドイヤーウェルト",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ1",
				"categorySlug": "category1",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "アグレット",
				"titleEn": "Aglet",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			}
		]
	},
	{
		"date": "2024-11-30",
		"items": [
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "グッドイヤーウェルト",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ1",
				"categorySlug": "category1",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "アグレット",
				"titleEn": "Aglet",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "グッドイヤーウェルト",
				"titleEn": "Goodyear Welt",
				"categoryName": "カテゴリ1",
				"categorySlug": "category1",
				"ts": 1758072228543
			},
			{
				"url": "http://127.0.0.1:9292/pages/dictionary/goodyear-welt",
				"title": "\n\t\t\tグッドイヤーウェルト\n – Roots&Routes | REGAL SHOES",
				"titleJa": "アグレット",
				"titleEn": "Aglet",
				"categoryName": "カテゴリ2",
				"categorySlug": "category2",
				"ts": 1758072228543
			}
		]
	}
]
*/